import React from "react";

import { Label } from "@busbud/horizon";

import type { SimplifiedTerms } from "@app/modules/terms/flatten-terms";
import type { TripOption } from "@app/types/results-types";

import { LocalizedPrice } from "../../../components/localized-price";
import { SelectableCard } from "../../../components/selectable-card/selectable-card";
import { SimplifiedTermsEntry } from "../../../components/terms-and-conditions/components";
import { getFareDisplayPrice } from "../../../helpers/udm/trip-fares";

interface Props extends Omit<TripOption, "terms" | "trip_id"> {
  terms: SimplifiedTerms[];
  selected: boolean;
  onSelect: () => void;
  base_price_in_cents: number;
}

export const FareCard: React.FC<Props> = ({
  fare_name,
  price_in_cents,
  terms,
  selected,
  onSelect,
  is_sold_out,
  base_price_in_cents
}) => {
  const fare_display_price = getFareDisplayPrice(
    price_in_cents,
    base_price_in_cents
  );

  const sign = fare_display_price >= 0 && "+";
  return (
    <SelectableCard
      label={fare_name}
      extra={
        <Label
          size="lg"
          fontWeight="bold"
          data-testid="trip-fare-option-price"
          className="text-color-scheme-interactive-link-500"
          as="p"
        >
          {sign}
          <LocalizedPrice price_in_cents={fare_display_price} />
        </Label>
      }
      checked={selected}
      onChange={onSelect}
      disabled={is_sold_out}
      dataCy="fare-card"
    >
      <div className="flex flex-col gap-100">
        {terms.map((terms, index) => {
          return <SimplifiedTermsEntry key={index} terms={terms} />;
        })}
      </div>
    </SelectableCard>
  );
};
